module.exports = __webpack_public_path__ + "static/media/laundry.c0dc4cba.png";